export default "__VITE_PUBLIC_ASSET__dcc49cd9__"